import { formatter as abyssFormatter } from '@abyss/ui/tools/formatter';
import { formatCapitalCase } from './types/formatCapitalCase';

const formatters = {
  capitalCase: formatCapitalCase,
};

export const formatter = (type, ...args) => {
  const formatterType = formatters[type];
  if (formatterType) {
    return formatterType(...args);
  }
  return abyssFormatter(type, ...args);
};
